import {manualPaymentCancelConstants} from "../../../../constants/Payment/manualPaymentCancel.constants";

const initialState = {
    cancelFetching: false,
    cancelData: null,
    cancelError: false,
    detailFetching: false,
    detailData: null,
    detailError: false,
    auditFetching: false,
    auditData: null,
    auditError: false,
};

export default function (state = initialState, action) {
    switch (action.type) {

        case manualPaymentCancelConstants.MANUAL_PAYMENT_CANCEL_PENDING:
            return {
                ...state,
                cancelFetching: true,
                cancelData: null,
                cancelError: false,
            };
        case manualPaymentCancelConstants.MANUAL_PAYMENT_CANCEL_FULFILLED:
            return {
                ...state,
                cancelFetching: false,
                cancelError: false,
                cancelData: action.payload,
            };
        case manualPaymentCancelConstants.MANUAL_PAYMENT_CANCEL_REJECTED:
            return {
                ...state,
                cancelFetching: false,
                cancelError: action.payload,
            };

        case manualPaymentCancelConstants.MANUAL_PAYMENT_DETAIL_PENDING:
            return {
                ...state,
                detailFetching: true,
                detailData: null,
                detailError: false,
            };
        case manualPaymentCancelConstants.MANUAL_PAYMENT_DETAIL_FULFILLED:
            return {
                ...state,
                detailFetching: false,
                detailError: false,
                detailData: action.payload,
            };
        case manualPaymentCancelConstants.MANUAL_PAYMENT_DETAIL_REJECTED:
            return {
                ...state,
                detailFetching: false,
                detailError: action.payload,
            };

        case manualPaymentCancelConstants.MANUAL_PAYMENT_AUDIT_PENDING:
            return {
                ...state,
                auditFetching: true,
                auditData: null,
                auditError: false,
            };
        case manualPaymentCancelConstants.MANUAL_PAYMENT_AUDIT_FULFILLED:
            return {
                ...state,
                auditFetching: false,
                auditError: false,
                auditData: action.payload,
            };
        case manualPaymentCancelConstants.MANUAL_PAYMENT_AUDIT_REJECTED:
            return {
                ...state,
                auditFetching: false,
                auditError: action.payload,
            };

        case manualPaymentCancelConstants.MANUAL_PAYMENT_CANCEL_CLEAR:
            return {
                ...state,
                cancelFetching: false,
                cancelData: null,
                cancelError: false,
            };
        case manualPaymentCancelConstants.MANUAL_PAYMENT_DETAIL_CLEAR:
            return {
                ...state,
                detailFetching: false,
                detailData: null,
                detailError: false,
            };
        case manualPaymentCancelConstants.MANUAL_PAYMENT_AUDIT_CLEAR:
            return {
                ...state,
                auditFetching: false,
                auditData: null,
                auditError: false,
            };
        case "CLEAR_STATE":
            return {
                ...initialState
            };
        default:
            return state;
    }
}
